<template>
  <div class="autocomplete">
    <autocomplete
        :search="search"
        placeholder="Search"
        aria-label="Search for a country"
        :debounceTime="50"
        @submit="handleSubmit"
    >

      <template #result="{ result, props }">
        <li
            v-bind="props"
            class="autocomplete-result wiki-result"
        >
          <div class="wiki-title">
            {{ result.title }}
          </div>
          <div class="wiki-snippet" v-html="result.snippet" />
        </li>
      </template>


    </autocomplete>

  </div>

</template>

<script>

//https://autocomplete.trevoreyre.com/#/vue-component?id=result

import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';

export default {
  name: "vue-autocomplete",
  props:
      {
        searchUrl: {
          type: String,
          required: true
        }

      },
  data() {
    return {
      countries: ['Japan', 'Korea', 'China', 'Canada']
    }
  },
  methods: {

    search(input) {
      console.log(input);

      const url = '/search'+ `?q=${encodeURI(input)}`;

      //const url = this.searchUrl + `?q=${encodeURI(input)}`;

      //console.log(url);

      return new Promise(resolve => {
        if (input.length < 3) {
          return resolve([])
        }

        fetch(url)
            .then(response => response.json())
            .then(data => {
              console.log(data);
              return resolve(data);
            })
      })
    },
    getResultValue(result) {
      return result.title;
    },
    getResultUrl(result){
        return '/session/' + result.id
    },
    handleSubmit(result)  {
      window.open(this.getResultUrl(result),'_self')
    }
  },


}


</script>

<style>

nav .autocomplete-input{
  background-color: transparent;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid black;
  padding: 7px 7px 7px 48px;
}

nav .autocomplete-result-list
{
  border: none;
}

nav .autocomplete-result-list li
{
  cursor: pointer;
  color: #06bcef;
}
</style>